__turbopack_context__.v({
  "Content": "login-module__KLvTmW__Content",
  "Root": "login-module__KLvTmW__Root",
  "SubTitle": "login-module__KLvTmW__SubTitle",
  "Title": "login-module__KLvTmW__Title",
});
